// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"92136488","703":"23eeaba6","787":"22747b40"}[chunkId] + ".chunk.js";
};